import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './coffee_v2/Header';
import Footer from './coffee_v2/Footer';
import Home from './coffee_v2/Home';
import Menu from './coffee_v2/Menu';
import Beans from './coffee_v2/Beans';
import Visit from './coffee_v2/Visit';

export default function CoffeeShopTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F0E4D0]" data-testid="bb-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`bb-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'menu' && <Menu setPage={setPage} />}
          {page === 'beans' && <Beans setPage={setPage} />}
          {page === 'visit' && <Visit setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
